<template>
  <div v-if="list" :class="fieldClass" class="p-modalLikeBox">
    <div class="p-modalLikeBox__header">
      <p class="p-modalLikeBox__header__text">
        {{ filterName }}
        <input
          :id="`${fieldIdPrefix}_all`"
          v-model="allChecked"
          :checked="allChecked"
          class="c-checkbox__input"
          type="checkbox"
          @change="toggleAllChecked"
        >
        <label class="c-checkbox__label" :for="`${fieldIdPrefix}_all`">{{ headText }}</label>
      </p>
    </div>
    <div class="p-modalLikeBox__body">
      <ul class="c-checkbox">
        <li
          v-for="( item, i ) in list"
          :key="i"
          class="c-checkbox__item"
        >
          <input
            :id="`${fieldIdPrefix}_${item[valueKey]}`"
            class="c-checkbox__input"
            type="checkbox"
            :checked="filterTypeFormValues.includes(item[valueKey])"
            :value="item.uuid"
            @change="setFilterValues({ target: filterType, value: item[valueKey] })"
          >
          <label
            class="c-checkbox__label"
            :for="`${fieldIdPrefix}_${item[valueKey]}`"
            v-text="item.name"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FilterItem',
  props: {
    list: {
      type: Array,
      required: true,
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    storeName: {
      type: String,
      default: 'companiesSearchAttributes',
    },
    headText: {
      type: String,
      required: true,
    },
    filterName: {
      type: String,
      default: '',
    },
    filterType: {
      type: String,
      required: true,
    },
    fieldClass: {
      type: String,
      default: 'p-filters__item__l__12 p-filters__item__s__12 p-filters__item__m__12'
    }
  },
  emits: ['change-check-box'],
  data: function() {
    return {
      allChecked: true,
    }
  },
  computed: {
    filterTypeFormValues () {
      return this.$store.state[this.storeName].formValues[this.filterType]
    },
    fieldIdPrefix () {
      return `${this.storeName}_${this.filterType}_form_${this.filterType}`
    },
  },
  mounted () {
    if (this.filterTypeFormValues.length !== this.list.length) this.allChecked = false
  },
  methods: {
    setFilterValues (payload) {
      this.allChecked = false
      this.$store.commit(`${this.storeName}/setFilterValues`, payload)
      this.handleChangeCheckBox()
    },
    toggleFilterValues (payload) {
      this.$store.commit(`${this.storeName}/toggleFilterValues`, payload)
      this.handleChangeCheckBox()
    },
    toggleAllChecked () {
      this.toggleFilterValues({
        target: this.filterType,
        allChecked: this.allChecked,
        initialValues: this.list.map(item => item[this.valueKey])
      })
    },
    handleChangeCheckBox() {
      this.$emit('change-check-box')
    }
  }
}
</script>

<style lang="scss" scoped>
.p-modalLikeBox {
  &__header__text {
    color: #3A3B3F;
    background: #F5F6F9;
    .c-checkbox__label {
      margin-left: 16px;
      font-weight: normal;
    }
  }
}
.p-modalLikeBox:not(:first-of-type) {
  margin-top: 12px;
}
.p-modalLikeBox:not(:last-of-type) {
  margin-bottom: 12px;
}
.c-checkbox {
  padding: 24px;
}
</style>
